import { useTraverse } from '../hooks';

export default function useMakeInvisible() {
  useTraverse(() => {
    return o => {
      if (o.name.includes('collision_mesh')) o.material.visible = false;
    };
  });
}
